import React from "react";
import { TableBody } from "@material-ui/core";
import _ from "lodash";
import numeral from "numeral";
import moment from "moment";

import EmptyCashflows from "./EmptyCashflows";
import CashflowHeaderRow from "./CashflowHeaderRow";
import { StyledTableCell, StyledTableHeaderCell, StyledTable, StyledCashFlowTableRow } from "./CashFlowsTable";

const CashflowRow = ({ cashflow }) => {
  const isCurrentPeriod = moment.utc().isBetween(moment.utc(cashflow.startDate), moment.utc(cashflow.endDate));

  return (
    <StyledCashFlowTableRow isCurrent={isCurrentPeriod}>
      <StyledTableCell>{moment(cashflow.startDate).utc().format("MM/DD/YYYY")}</StyledTableCell>
      <StyledTableCell>{moment(cashflow.endDate).utc().format("MM/DD/YYYY")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.beginPrincipalBalance).format("$0,0.00")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.noteRate).format("0.00%")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.discountRate).format("0.00%")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.discountFactor).format("0.00")}</StyledTableCell>
      <StyledTableCell>{numeral(cashflow.fvPayment).format("$0,0.00")}</StyledTableCell>
    </StyledCashFlowTableRow>
  );
};
const DebtValuationCashflows = ({ cashflows, onExport, classes }) => {
  if (_.isEmpty(cashflows)) {
    return <EmptyCashflows />;
  }

  return (
    <StyledTable className="hide-scrollbar">
      <CashflowHeaderRow>
        <StyledTableHeaderCell>Start Date</StyledTableHeaderCell>
        <StyledTableHeaderCell>End Date</StyledTableHeaderCell>
        <StyledTableHeaderCell>Beginning Balance</StyledTableHeaderCell>
        <StyledTableHeaderCell>Note Rate</StyledTableHeaderCell>
        <StyledTableHeaderCell>Discount Rate</StyledTableHeaderCell>
        <StyledTableHeaderCell>Discount Factor</StyledTableHeaderCell>
        <StyledTableHeaderCell>FV Payment</StyledTableHeaderCell>
      </CashflowHeaderRow>
      <TableBody>
        {cashflows.map(x => <CashflowRow key={x.id} cashflow={x} />)}
      </TableBody>
    </StyledTable>
  );
};
export default DebtValuationCashflows;
